"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTag = exports.INBOX_REMOVE_TAG = void 0;
var INBOX_REMOVE_TAG = "inbox/REMOVE_TAG";
exports.INBOX_REMOVE_TAG = INBOX_REMOVE_TAG;

var removeTag = function removeTag(messageId, tag) {
  return {
    type: INBOX_REMOVE_TAG,
    payload: {
      tag: tag,
      messageId: messageId
    }
  };
};

exports.removeTag = removeTag;